// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ln-0";
export var assigneeDetails = "_ln-1";
export var assigneeInfo = "_ln-2";
export var dropdownContainer = "_ln-4";
export var dropdownImage = "_ln-5";
export var editAssigneeInfo = "_ln-3";
export var editAssigneeModalContainer = "_ln-6";
export var hidden = "_ln-8";
export var input = "_ln-7";